import { TOUJOU_EVENT_CONTACT_DIALOG_OPEN } from '../utils/constants';

/**
 * A class that handles the toggle button for opening the contact dialog.
 * Dispatches a custom event when clicked.
 */
class ContactToggle {
  /**
   * @param {HTMLButtonElement} toggle - The toggle button element
   */
  constructor(toggle) {
    /** @type {HTMLButtonElement} */
    this.toggle = toggle;

    /** @type {HTMLDialogElement} */
    this.targetEl = document.getElementById(this.toggle.getAttribute('aria-controls'));

    this._onClick = this._onClick.bind(this);
    this.toggle.addEventListener('click', this._onClick);

    this._onDialogOpen = this._onDialogOpen.bind(this);
    window.addEventListener(TOUJOU_EVENT_CONTACT_DIALOG_OPEN, this._onDialogOpen);

    this._onDialogClose = this._onDialogClose.bind(this);
    this.targetEl.addEventListener('close', this._onDialogClose);
  }

  /**
   * Handles click events on the toggle and dispatches a custom event.
   * @private
   */
  _onClick() {
    if (this.toggle.getAttribute('aria-pressed') === 'false') {
      this.toggle.dispatchEvent(new CustomEvent(TOUJOU_EVENT_CONTACT_DIALOG_OPEN, {
        bubbles: true,
        composed: true,
      }));
    }
  }

  /**
   * Handles custom event on the window element and sets
   * the aria-pressed attribute to 'true'
   * @private
   */
  _onDialogOpen() {
    this.toggle.setAttribute('aria-pressed', 'true');
  }

  /**
   * Handles close events on the target <dialog> element and sets
   * the aria-pressed attribute to 'false'
   * @private
   */
  _onDialogClose() {
    this.toggle.setAttribute('aria-pressed', 'false');
  }
}

/**
 * Initializes the contact toggles if any exist on the page.
 * Prevents multiple initializations per toggle using a custom instance property.
 */
function initContactToggle() {
  /** @type {HTMLButtonElement|null} */
  const contactToggles = document.querySelectorAll('.topbar-contact__toggle, .navigation-contact__toggle');

  if (!contactToggles.length) return;

  contactToggles.forEach((toggle) => {
    if (!toggle.contactToggleInstance) {
      // eslint-disable-next-line no-param-reassign
      toggle.contactToggleInstance = new ContactToggle(toggle);
    }
  });
}

if (document.readyState !== 'loading') {
  setTimeout(initContactToggle);
} else {
  document.addEventListener('DOMContentLoaded', initContactToggle, { once: true });
}
